<template>
  <div class="pannel6">
    <NavTiltle :titleNav="title" :titleTextNav="titleText" />
    <div class="pc-conent">
      <div class="big-box">
        <el-row class="gallery" type="flex">
          <el-col
            v-for="(adv, idx) in techAdvances"
            :key="adv.id"
            @click.native="dec(idx)"
            :xs="4.8"
            :sm="4.8"
            :md="4.8"
            :lg="4.8"
            :xl="4.8"
            class=""
          >
            <div
              class="img-block grid-content de"
              :class="!(idx == 1 || idx == 3) ? 'top' : ''"
            >
              <img :src="adv.path" alt="advimg" />
              <!-- 蒙版 -->
              <div class="back-mark">
                <!-- <div class="big">
                  <span>{{ adv.name }}</span>
                  <p>{{ adv.dec }}</p>
                </div> -->
              </div>
              <div class="big">
                <span>{{ adv.name }}</span>
                <p>{{ adv.dec }}</p>
              </div>
              <div class="img-mark">
                <span class="font-Text">{{ adv.name }}</span>
                <!--  <div class="big">
                  <span>{{ adv.name }}</span>
                  <p>{{ adv.dec }}</p>
                </div> -->
              </div>
              <!-- <div class="img-mark" v-if="idx==sci?true:false"></div> -->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- moblie -->
    <div class="moblie-conent">
      <div class="img-scroll">
        <div class="img-box" v-for="adv in techAdvances" :key="adv.id">
          <img :src="adv.path" />
          <div class="back-mark"></div>
          <!-- <div class="big">
            <span>{{ adv.name }}</span>
            <p>{{ adv.dec }}</p>
          </div> -->
          <div class="img-mark">
            <!-- <span class="font-Text">{{ adv.name }}</span> -->
            <div class="big">
              <span>{{ adv.name }}</span>
              <p>{{ adv.dec }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavTiltle from "../components/NavTiltle.vue";
export default {
  name: "Pannel6",
  data() {
    return {
      sci: 0,
      title: "特殊实力",
      titleText: "SPECIAL STRENGTH",
      techAdvances: [
        {
          name: "化妆师知识库",
          path: require("./../assets/images/特殊实力/1.png"),
          id: 1,
          dec:
            "集合全球15万化妆师的实践经验，从化妆区域，到手法，到工具的知识汇总，与AI技术配合可做到千人千面的化妆指导",
        },
        {
          name: "美容师知识库",
          path: require("./../assets/images/特殊实力/2.png"),
          id: 2,
          dec:
            "拥有数万美容师对人脸皮肤分析经验和超过百万级美容师参与的面部实例数据分析",
        },
        {
          name: "服装师知识库",
          path: require("./../assets/images/特殊实力/3.png"),
          id: 3,
          dec: "汇集色彩学、几何学、视觉美学、流行趋势数据等多维度的数据分析",
        },
        {
          name: "护肤品成分配方库",
          path: require("./../assets/images/特殊实力/4.png"),
          id: 4,
          dec: "收录230多万条全球护肤商品成分配方定期更新",
        },
        {
          name: "彩妆商品库",
          path: require("./../assets/images/特殊实力/5.png"),
          id: 5,
          dec:
            "现有3478个彩妆品牌+133万件彩妆单品+1561种口红色号产品库，实时抓取，实时更新",
        },
      ],
    };
  },
  components: {
    NavTiltle,
  },
  methods: {
    dec(ind) {
      this.sci = ind;
      console.log(this.techAdvances[ind].path, ind);
      // techAdvances[ind]
    },
  },
};
</script>

<style lang="less" scoped>
.pannel6 {
  width: 100%;
  // height: 60rem;
  height: auto;
  background-image: url(../assets/images/markM.png);
  background-position: 100% 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  // padding: 0 2.4375rem;
  // padding: 0 11.25rem;
  padding-bottom: 303px;
  .moblie-conent {
    display: none;
  }
  .pc-conent {
    display: block;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    // padding: 0 2.4375rem;
    // padding: 0 11.25rem;
    // padding: 0 8% 0;
    padding: 0 200px 0;
    .big-box {
      // width: 80%;
      // background: #1B7E5A;
      height: 100%;
    }
    .gallery {
      .top {
        position: relative;
        top: 212px;
      }
      .de {
        transition-duration: 0.5s;
        //       /*     以下三值为默认值，稍后会详细介绍 */
        transition-property: all;
        transition-timing-function: ease;
        transition-delay: 0s;
      }
      .img-block {
        // background: #0066A9;
        height: 100%;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .back-mark {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 9;
          background: linear-gradient(
            180deg,
            rgba(98, 11, 47, 0.15) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        .big {
          position: absolute;
          width: 80%;
          height: auto;
          z-index: 9;
          display: none;
          left: 50%;
          bottom: 20%;
          transform: translate(-50%, 20%);
          // background: antiquewhite;
          // position: absolute;
          // width: 100%;
          // height: auto;
          // bottom: 0;
          // left: 0;
          // z-index: 9;
          // display: none;
          span {
            display: inline-block;
            width: 100%;
            height: 30px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 30px;
            letter-spacing: 3px;
            position: relative;
            transform: translate(-50%, -18%);
            top: -18%;
            left: 50%;
            text-align: center;
          }
          p {
            width: 100%;
            height: 100%;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            // line-height: 22px;
            letter-spacing: 5px;
            margin: 0;
            box-sizing: border-box;
            // padding: 0 12px;
          }
        }
        .img-mark {
          width: 40px;
          height: 3px;
          background: #ffffff;
          // background: rgba(255, 255, 255, 0.5);
          box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
          position: relative;
          transform: translate(-50%, -8%);
          top: -8%;
          left: 50%;
          z-index: 9;
          span {
            display: inline-block;
            width: 300px;
            // width: 159px;
            height: 30px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 30px;
            letter-spacing: 3px;
            position: relative;
            // transform: translate(-50%, -18%);
            // top: -18%;
            transform: translate(-50%, -118%);
            top: -18%;
            left: 50%;
            text-align: center;
          }
        }
        &:hover {
          .img-mark {
            background: rgba(255, 255, 255, 0);
            .font-Text {
              display: none;
            }
          }
          .back-mark {
            z-index: 0;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.8) 100%
            );
          }
          .big {
            z-index: 9999999999;
            display: block;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1280px) {
  // .el-col-md-4 {
  // 	display: inline-block;
  // 	width: 20%; // 重置宽度为 1/5
  // }
  .pannel6 {
    width: 100%;
    height: auto;
    // height: 50rem;
    background-image: url(../assets/images/markM.png);
    background-position: 100% 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    // padding: 0 2.4375rem;
    // padding: 0 11.25rem;
    padding-bottom: 303px;
    // padding: 0 10% 0;
    .moblie-conent {
      display: none;
    }
    .pc-conent {
      display: block;
      width: 100%;
      // height:100%;
      // background-color: #000000;
      box-sizing: border-box;
      // padding: 0 10% 0;
      padding: 0 200px 0;
      .big-box {
        // width: 80%;
        // background: #1B7E5A;
        height: 100%;
      }
      .gallery {
        .top {
          position: relative;
          // top: 212px;
        }
        .de {
          transition-duration: 0.5s;
          //       /*     以下三值为默认值，稍后会详细介绍 */
          transition-property: all;
          transition-timing-function: ease;
          transition-delay: 0s;
        }
        .img-block {
          // background: #0066A9;
          height: 100%;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .back-mark {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 9;
            background: linear-gradient(
              180deg,
              rgba(98, 11, 47, 0.15) 0%,
              rgba(0, 0, 0, 0.7) 100%
            );
          }
          .big {
            position: absolute;
            width: 80%;
            height: auto;
            z-index: 9;
            display: none;
            left: 50%;
            bottom: 20%;
            transform: translate(-50%, 20%);
            // background: antiquewhite;
            // position: absolute;
            // width: 100%;
            // height: auto;
            // bottom: 0;
            // left: 0;
            // z-index: 9;
            // display: none;
            span {
              display: inline-block;
              width: 100%;
              height: 30px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 30px;
              letter-spacing: 3px;
              position: relative;
              transform: translate(-50%, -18%);
              top: -18%;
              left: 50%;
              text-align: center;
            }
            p {
              width: 100%;
              height: 100%;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 22px;
              letter-spacing: 5px;
              margin: 0;
              box-sizing: border-box;
              // padding: 0 12px;
            }
          }
          .img-mark {
            width: 40px;
            height: 3px;
            background: #ffffff;
            // background: rgba(255, 255, 255, 0.5);
            box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
            position: relative;
            transform: translate(-50%, -8%);
            top: -8%;
            left: 50%;
            z-index: 9;
            span {
              display: inline-block;
              width: 159px;
              height: 30px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 30px;
              letter-spacing: 3px;
              position: relative;
              // transform: translate(-50%, -18%);
              // top: -18%;
              transform: translate(-50%, -118%);
              top: -18%;
              left: 50%;
              text-align: center;
            }
          }
          &:hover {
            .img-mark {
              background: rgba(255, 255, 255, 0);
              .font-Text {
                display: none;
              }
            }
            .back-mark {
              z-index: 0;
              background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.8) 100%
              );
            }
            .big {
              z-index: 9999999999;
              display: block;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 769px) {
  .pannel6 {
    width: 100%;
    // height: 486px;
    height: auto;
    background-image: url(../assets/images/markM.png);
    background-position: 100% 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding-bottom: 41px;
    .pc-conent {
      display: none;
    }
    .moblie-conent {
      display: block;
      height: 100%;
      box-sizing: border-box;
      padding: 0 10px 0 20px;
      .img-scroll {
        display: flex;
        height: auto;
        // height: 308px;
        overflow-y: hidden;
        overflow-x: auto;
        .img-box {
          flex-shrink: 0;
          width: 43%;
          height: 100%;
          margin-right: 10px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .back-mark {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 9;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.8) 100%
            );
          }
          .img-mark {
            position: relative;
            transform: translate(-50%, -8%);
            top: -8%;
            left: 50%;
            z-index: 9;
            .big {
              bottom: 20%;
              width: 100%;
              height: 200px;
              position: absolute;
              left: 54%;
              transform: translate(-54%, 15%);
              span {
                display: inline-block;
                width: 100%;
                height: 30px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 30px;
                letter-spacing: 2px;
                position: relative;
                transform: translate(-50%, -18%);
                top: -18%;
                left: 50%;
                text-align: center;
              }
              p {
                width: 100%;
                height: 167px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 18px;
                letter-spacing: 1px;
                box-sizing: border-box;
                padding: 0 14px;
                // text-align: center;
              }
            }
          }
        }
      }
    }
  }
}
</style>
